import React from 'react'
import Slider from 'react-slick'

import PersonalBlock from '../PersonalBlock/PersonalBlock'

import './TeamList.css'

const list = [
  {
    name: 'Mikhail Stepanov',
    title: 'Software Engineer',
    faceURL: 'misha.jpg',
    bgColor: '#19d0cf',
  },
  {
    name: 'Mishall Afzal',
    title: 'Software Engineer',
    faceURL: 'mishall.jpg',
    bgColor: '#7e3fdb',
  },
  {
    name: 'Giovanni Martinez',
    title: 'Founder',
    faceURL: 'gio.jpg',
    bgColor: '#e8c466',
  },
]

const TeamList = () => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          variableWidth: true,
        },
      },
    ],
  }
  return (
    <React.Fragment>
      <div className="fmbm-our_team_block__team_list">
        <Slider {...settings}>
          {list.map((person, idx) => {
            return (
              <PersonalBlock className="someShit" person={person} key={idx} />
            )
          })}
        </Slider>
      </div>
    </React.Fragment>
  )
}

export default TeamList



// WEBPACK FOOTER //
// ./src/Components/TeamList/TeamList.js